import { action, observable } from 'mobx';

import DialogStore from 'bz-stores/mobx/dialog-store';

import createContext from 'bz-utilities/hooks/context-v2';

export const [EmailWarningDialogStoreContext, useEmailWarningDialogStore] =
  createContext<EmailWarningDialogStore>('EmailWarningDialogStore');

class EmailWarningDialogStore extends DialogStore {
  @observable checked: boolean = false;

  @action.bound
  open() {
    this._open();
    this.checked = false;
  }

  @action.bound
  toggle() {
    this.checked = !this.checked;
  }
}

export default EmailWarningDialogStore;
